export const WorkspaceRelatedTags = [
  'Tour',
  'Tours',
  'DemoTours',
  'ArchivedTours',
  'TourFrame',
  'TourFrames',
  'TourEvents',
  'Revisions',
  'Demo',
  'Demos',
  'ArchivedDemos',
  'RecordingDemos',
  'Shares',
  'Event',
  'Events',
  'Recording',
  'Recordings',
  'ArchivedRecordings',
  'Presentation',
  'Presentations',
  'DemoPresentations',
  'ArchivedPresentations',
  'Draft',
  'Drafts',
  'Edit',
  'Edits',
  'RecordingDraft',
  'ChartsTemplates',
  'Modifications',
  'Modification',
  'Workspaces',
  'Workspace',
  'WorkspaceMembers',
  'ArchivedWorkspaces',
  'WorkspaceAssets',
  'Folder',
  'Folders',
  'ArchivedFolders',
  'FolderAssets',
  'ArchivedFolderAssets',
  'Playbook',
  'Plays',
  'ArchivedPlays',
  'QueuedPlays',
  'PlayData',
  'ModificationsCount',
  'Notes',
  'DemoLinks',
  'Tags',
  'TextExtractionIsCSVEmpty',
] as const;

export const OrganizationScopeTags = [
  ...WorkspaceRelatedTags,
  'Organizations',
  'AdminOrganizations',
  'Invite',
  'Invites',
  'InviteLinks',
  'Roles',
  'Role',
  'TeamAcitvity',
  'TourThemes',
  'TourTheme',
  'PendingAdminAccessRequests',
  'HandledAdminAccessRequests',
  'Integrations',
  'IntegrationsConfig',
  'Integration',
  'NotificationsSettings',
  'TopAssets',
  'FavoriteAssets',
  'WorkspacesSearch',
] as const;

export const Tags = [...OrganizationScopeTags, 'Organization', 'User'] as const;
export type Tag = (typeof Tags)[number];
